import type { DataTableRow } from "@client-shared";
import type { LabelPrintBatch } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { getReadableBatchId, setBatchesTableRowTestId } from "../batches-table.utils";

export const BatchIdCellMarkup = (props: CellContext<DataTableRow<LabelPrintBatch>, unknown>) => {
  const batchId = props.row.original.batchId;

  return (
    <span className="font-mono text-sm font-medium" data-testid={setBatchesTableRowTestId(batchId)} title={batchId}>
      {getReadableBatchId(batchId)}
    </span>
  );
};
